import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

import {GoogleAnalyticsService, UtilService} from '../../../../core';
import {TemperatureUnit} from '../../../../shared';
import {NotificationService} from '../../../shared';

import {forkJoin, Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';

import * as fromRoot from '../../../../reducers';
import * as fromAfbApi from '../../../../afb-api/reducers';
import {OrganizationWithToken} from '../../../../core/models/core';
import {filter} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {Device} from '../../../../afb-api/models/device';
import {AirnoteService} from '../../../../afb-api/services/airnote.service';
import {AirComponentType} from '../../../../afb-api/enums/air-component-type.enum';
import {Airnote} from '../../../../afb-api/models/airnote';

@Component({
  selector: 'awair-airnote-dialog',
  templateUrl: './airnote-dialog.component.html',
  styleUrls: ['./airnote-dialog.component.scss']
})

export class AirnoteDialogComponent implements OnInit {

  selectedOrganization$: Observable<OrganizationWithToken> = this.rootStore.pipe(
    select(fromRoot.selectedOrganization),
    filter((selectedOrganization: OrganizationWithToken) => selectedOrganization != null)
  );

  selectedDevice: Device;
  deviceName: string;
  date: Date;
  value: number;
  valueColor: any;
  type: AirComponentType;
  note: string = '';
  airnote: Airnote;
  temperatureUnit: TemperatureUnit;

  deviceNameList: string = '';

  constructor(private rootStore: Store<fromRoot.State>,
              private afbApiStore: Store<fromAfbApi.State>,
              private airNoteService: AirnoteService,
              private utilService: UtilService,
              private googleAnalyticsService: GoogleAnalyticsService,
              private notificationService: NotificationService,
              private myDialogRef: MatDialogRef<AirnoteDialogComponent>) {
  }

  ngOnInit() {
    if (this.airnote != null) {
      this.note = this.airnote.content.text;
    }
  }

  close(): void {
    if (this.note.length > 0 && (this.airnote != null && this.note !== this.airnote.content.text) ||
      this.note.length > 0 && this.airnote == null) {
      if (confirm('Changes will not be saved.\nAre you sure you want to exit?')) {
        this.myDialogRef.close();
      }
    } else {
      this.myDialogRef.close();
    }
  }

  saveAirNote(organizationToken: string) {
    if (this.airnote != null) {
      // Edit
      const obs = [];

      obs.push(this.airNoteService.patchAirnoteText({
        organizationToken,
        airnoteId: this.airnote.content.id,
        text: this.note
      }));

      forkJoin(obs).subscribe(
        (airnotes: Airnote[]) => {
          this.googleAnalyticsService.emitEvent('Air Note', 'edit', 'Success');
          this.notificationService.announceAirNote(airnotes[0]);
          this.myDialogRef.close();
        },
        (error: HttpErrorResponse) => {
          this.googleAnalyticsService.emitEvent('Air Note', 'edit', 'Fail');
          alert('Failed to save air note.\n Please try again later');
          this.myDialogRef.close();
        }
      );
    } else {
      // Create
      if (this.deviceNameList === 'All') {
        /* Add air note for organization graph in the future */
      } else {
        const obs = [];

        if (this.selectedDevice != null) {
          obs.push(this.airNoteService.postAirnote({
            organizationToken,
            deviceType: this.selectedDevice.deviceType,
            deviceId: this.selectedDevice.deviceId,
            date: this.date,
            component: this.type,
            value: this.value,
            text: this.note,
            labels: []
          }));
        }

        forkJoin(obs).subscribe(
          (airnotes: Airnote[]) => {
            this.googleAnalyticsService.emitEvent('Air Note', 'create', 'Success');
            this.notificationService.announceAirNote(airnotes[0]);
            this.myDialogRef.close();
          },
          (error: HttpErrorResponse) => {
            this.googleAnalyticsService.emitEvent('Air Note', 'create', 'Fail');
            alert('Failed to save air note.\n Please try again later');
            this.myDialogRef.close();
          }
        );
      }
    }
  }
}
